import type SolrQuery from '~/utils/solr/SolrQuery';

type SolrQueryResponse<T> = Promise<{
  data: Readonly<Ref<Array<NonNullable<T>>>>;
  numFound: Ref<number>;
  numFoundExact: Ref<boolean>;
  start: Ref<number>;
}>;

type SolrQueryParams = {
  q: SolrQuery;
};

export const useSolrQuery = async <T>({ q }: SolrQueryParams): SolrQueryResponse<T> => {
  const data: Ref<Array<NonNullable<T>>> = ref([]);
  const numFound: Ref<number> = ref(0);
  const numFoundExact: Ref<boolean> = ref(true);
  const start: Ref<number> = ref(0);

  const result = await q.query<NonNullable<T>>();
  data.value = result.docs;
  numFound.value = result.numFound;
  numFoundExact.value = result.numFoundExact;
  start.value = result.start;

  return {
    data,
    numFound,
    numFoundExact,
    start,
  };
};
